export const themes = ['primary', 'secondary'] as const
